import type {
  PricePeriodType,
  PriceValue
} from '@elfsight/configurator-contracts';
import type {
  PaymentCurrency,
  ProductData,
  SubscriptionProductData
} from '@elfsight/lib-stripe-integration';

interface PeriodConfig {
  recurringInterval: SubscriptionProductData['recurringInterval'];
  recurringIntervalCount: number;
}

const STRIPE_PERIOD_MAP: Record<PricePeriodType, PeriodConfig> = {
  day: { recurringInterval: 'day', recurringIntervalCount: 1 },
  week: { recurringInterval: 'week', recurringIntervalCount: 1 },
  month: { recurringInterval: 'month', recurringIntervalCount: 1 },
  quarter: { recurringInterval: 'month', recurringIntervalCount: 4 },
  '6 months': { recurringInterval: 'month', recurringIntervalCount: 6 },
  year: { recurringInterval: 'year', recurringIntervalCount: 1 }
};

export const getProductPriceData = ({
  currency,
  period,
  pricingModel,
  price
}: PriceValue): Omit<ProductData, 'name'> => {
  const stripePeriod = STRIPE_PERIOD_MAP[period] ?? {
    period,
    recurringIntervalCount: 1
  };

  return {
    currency: currency as PaymentCurrency,
    quantity: 1,
    amount: price,
    ...(pricingModel === 'subscription' && stripePeriod)
  };
};
